<template>
    <div class="mainPage">
        <div class="agentTip" v-if="!isChrome">
            <span>建议使用Chrome浏览器，以获得最佳体验</span>
            <div class="closeTip" @click="isChrome = true">×</div>
        </div>
        <div class="bannerCon">
          <img src="../img/winter/winter_banner.png" alt="">
        </div>
        <div class="content">
          <div class="moocCon">
            <h3>
              慕课 <span>Mooc</span>
            </h3>
            <div class="moocList">
              <div class="item" @click="tolive('https://mooc.chineseplus.net/dist/#/courseDetail?course_id=446')">
                <div>
                  <img src="../img/winter/hsk_1.png" alt="">
                  <div class="title">
                    HSK标准会话教程（1级）
                  </div>
                </div>
                <div class="hoverCon">
                  Play <span>学习</span> >
                </div>
              </div>
              <div class="item" @click="tolive('https://mooc.chineseplus.net/dist/#/courseDetail?course_id=447')">
                <div>
                  <img src="../img/winter/hsk_2.png" alt="">
                  <div class="title">
                    HSK标准会话教程（2级）
                  </div>
                </div>
                <div class="hoverCon">
                  Play <span>学习</span> >
                </div>
              </div>
              <div class="item" @click="tolive('https://mooc.chineseplus.net/dist/#/courseDetail?course_id=136')">
                <div>
                  <img src="../img/winter/hanzi.png" alt="">
                  <div class="title">
                    《汉字五千年》[英文版]
                  </div>
                </div>
                <div class="hoverCon">
                  Play <span>学习</span> >
                </div>
              </div>
              <div class="item" @click="tolive('https://mooc.chineseplus.net/dist/#/courseDetail?course_id=94')">
                <div>
                  <img src="../img/winter/story.png" alt="">
                  <div class="title">
                    《中国历史常识》
                  </div>
                </div>
                <div class="hoverCon">
                  Play <span>学习</span> >
                </div>
              </div>
              <div class="item" @click="tolive('https://mooc.chineseplus.net/dist/#/courseDetail?course_id=93')">
                <div>
                  <img src="../img/winter/culture.png" alt="">
                  <div class="title">
                    《中国文化常识》
                  </div>
                </div>
                <div class="hoverCon">
                  Play <span>学习</span> >
                </div>
              </div>
            </div>
          </div>
          <div class="courseListCon">
            <div>
              <h3>
                直播课 <span>Live Class</span>
              </h3>
            </div>
            <div class="tabCon">
              <span @click="isplayBack = false" :class="{'active': isplayBack == false}">
                直播 Live
              </span>
              <!-- <span  @click="currentStatus = 0" :class="{'active': currentStatus == 0}">
                预告
              </span> -->
              <span  @click="isplayBack = true" :class="{'active': isplayBack == true}">
                回放 Replay
              </span>
            </div>
            <ul class="list">
                <!-- <div v-if="currentStatus == 1 && !hasLive" class="noLive">
                  暂无直播
                </div> -->
                <li v-for="(item, index) in courseList" :key="item.id" :class="{'live': item.customStatus == 1, 'finished': item.customStatus == 2}"
                  v-show="isplayBack == item.isplayBack">
                    <div class="timeCon" >
                        <span class="time">{{new Date(+item.start_time).Format('YYYY.MM.DD hh:mm')}}-{{new Date(+item.end_time).Format('hh:mm')}}</span>
                        <span class="status live" v-if="item.customStatus == 1">
                            Live 直播进行中
                        </span>
                        <span class="status finished" v-if="item.customStatus == 2">
                            Finished 直播已结束
                        </span>
                        <span class="status notice" v-if="item.customStatus == 0">
                            Notice 直播预告
                        </span>
                    </div>
                    <div class="nameCon">
                        <div class="name" v-if="item.name">
                            <span>
                                {{item.name}}
                            </span>
                        </div>
                        <div class="name name_en" v-if="item.name_en">
                            <span>
                                {{item.name_en}}
                            </span>
                        </div>
                        
                    </div>
                    <div class="titleCon">
                        <div class="title">
                            <div class="en" v-if="item.teacher_name_en">
                                {{item.teacher_name_en}}
                            </div>
                            <div class="cn" v-if="item.teacher_name">
                                {{item.teacher_name}}
                            </div>
                        </div>
                        <div class="liveBtn">
                            <span class="join notOpen" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == false" @click="join(item, index, false)">
                                <span class="En">
                                    Not open
                                </span>
                                <span class="Cn">
                                    未开放
                                </span>
                            </span>
                            <span class="join replay" v-if="item.status == 3" @click="replay(item.video_url,item.id)">
                                <span class="En">
                                    Replay
                                </span>
                                <span class="Cn">
                                    课程回放
                                </span>
                            </span>
                            <span class="isOrder" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == true">
                                直播未开始 Coming Soon
                            </span>
                            <span class="join" v-if="item.status == 1 && item.customStatus == 1" @click="joinToLive(item, index)">
                                <span class="En">
                                    Enter
                                </span>
                                <span class="Cn">
                                    进入
                                </span>
                            </span>
                        </div>
                    </div>
                </li>
            </ul>
          </div>
          <div class="footer">
            <img src="../img/winter/winter_footer.png" alt="">
          </div>
        </div>


        <transition name="fade">
        <div id="videoPlayWrapper" v-if="isPlay">
            <div class="videoContent">
            <div class="closeVideo" @click="closeVideo()">×</div>
            <div class="videoContainer"><video :src="currentVideoUrl" id="liveVideo" controls controlsList="nodownload"></video></div>
            <!-- <div class="videoContainer"><video :src="currentVideoUrl" id="liveVideo" controls controlsList="nodownload"></video></div> -->
            </div>
        </div>
        </transition>
        
    </div>
</template>

<script>
import Qs from 'qs'

export default {
    name: 'chinesebridge',
    components: {
      
    },
    data: function () {
        return {
            isChrome: true,
            isLogin: false,
            isPlay: false,
            currentVideoUrl: '',
            user: {
                username: '',
                email: ''
            },
            isplayBack: false,
            hasLive: false,
            hasPlay: false,
            currentStatus: 1,
            subject_info: {},
            courseList: [],
            subject_id: null,
            beforeTime: 30, // 提前可进入直播间时间
            afterTime: 30 // 延后关闭直播间时间
        }
    },
    methods: {
        tolive (url) {
            window.open(url)
        },
        toLogin() {
            window.location.href =
            this.baseUrl +
            "user/api/login?" +
            "callback=" +
            encodeURIComponent(window.location.href);
        },
        toRegister() {
            window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
        },
        customCheckLogin() {
            this.checkLogin().then(res => {
                if(res.data.success){
                    this.isLogin = true
                    this.user = res.data.data
                } else {
                    this.isLogin = false
                }
                
            }).catch((r) => {
                console.log(r)
            })
        },
        toLogOut() {
            this.$utils.get('/user/api/logout').then(res => {
                if(res.data.success) {
                    this.isLogin = false
                }
            })
        },
        // 获取专题信息
        getSubjectInfo(alias) {
            this.$utils.get('/subject/subject/readbyalias', {
                alias
            }).then(res => {
                if(res.data.success) {
                    this.subject_info = res.data.data
                    this.getCourseInfo(this.subject_info.id)
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        // 获取课程列表
        getCourseInfo(id) {
            this.$utils.get('/subject/lesson/getlist', {
                subject_id: id,
                limit: 200
            }).then(res => {
                if(res.data.success) {
                    var now = new Date().getTime()
                    var endTime = now - this.afterTime * 60 * 1000;
                    var nowBeforeFiveMin = now + this.beforeTime * 60 * 1000
                    res.data.data.list.forEach(e => {
                        e.isOrder = false
                        e.customStatus = 0
                        e.isplayBack = false
                        if (nowBeforeFiveMin > e.start_time) {
                            e.customStatus = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                            // this.hasLive = true // 有直播
                        }
                        if (endTime > e.end_time) {
                            e.customStatus = 2
                            e.isplayBack = true
                            // this.hasPlay = true // 有回放
                        }
                    })
                    this.courseList = res.data.data.list
                    // this.checkOrdeList()
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        // 检查可预约直播间
        checkOrdeList() {
            const orderRoomId = []
            this.courseList.forEach(e => {
                if (orderRoomId.indexOf(e.room_id) == -1 && e.room_id != 0) {
                    orderRoomId.push(e.room_id)
                }
            })
            this.checkRoomsIsOrder(orderRoomId)
        },
        // 检查用户直播间状态
        checkRoomsIsOrder(arr) {
            const data = Qs.stringify({
                rooms: arr.toString(),
                user: this.user.email
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/get_user_rooms'+"?time=" +new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList.forEach((e, index) => {
                        if (res.data.data.hasOwnProperty(e.room_id)) {
                            this.courseList[index].isOrder = true
                            this.$set (this.courseList, index, this.courseList[index])
                        }
                    })
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        join(item, index, islive) {
            // if(!this.isLogin) {
            //     this.toLogin()
            //     return
            // }
            if (islive) {
                window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
            }
            // const data = Qs.stringify({
            //     room_id: item.room_id,
            //     user: this.user.email,
            //     secret: "03198325b8b61ccc3413cf7e754febea",
            //     key: "zyz",
            //     username: this.user.username,
            //     realname: this.user.username
            // })
            // this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/add_user'+"?time=" +new Date().valueOf(), data, {
            //     headers: {
            //         'Content-Type': 'application/x-www-form-urlencoded'
            //     }
            // }).then(res => {
            //     if (res.data.code == 0) {
            //         this.courseList[index].isOrder = true
            //         this.$set (this.courseList, index, this.courseList[index])
            //         if (islive) {
            //             window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
            //         }
            //     }
            // }).catch((r) => {
            //     console.log(r)
            // })
        },
        joinToLive(item, index) {
            window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
            // if(!this.isLogin) {
            //     this.toLogin()
            //     return
            // }
            // if(!item.isOrder) {
            //     this.join(item, index, true)
            // }else {
            //     window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
            // }
        },
        replay(url, id) {
            // if(!this.isLogin) {
            //     this.toLogin()
            //     return
            // }
            this.isPlay = true
            this.currentVideoUrl = url
            // this.courseRecord(id)
            // setTimeout(function() {
            //     $('#liveVideo').bind('contextmenu',function() { return false; })
            // }, 50)
        },
        // 回放观看记录
        courseRecord(id) {
            this.$utils.get('/subject/lesson/setrecord', {
                lesson_id: id
            })
        },
        closeVideo() {
            var myvideo = document.getElementById("liveVideo");
            if (!myvideo.paused) {
                myvideo.pause();
            }
            this.isPlay = false
        },
        checkChrome() {
            var isChrome = window.navigator.userAgent.indexOf("Chrome") > -1;
            if (!isChrome) {
                this.isChrome = false
            }
        }
    },
    mounted() {
        // this.subject_id = this.$route.query.id
        // this.customCheckLogin()
        this.getSubjectInfo('winter_olympics')
        this.checkChrome()
    }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">

.mainPage {
    width: 100%;
    text-align: center;
    position: relative;
    min-height: 100%;
    font-size: 0;
    .bannerCon {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .agentTip {
        width: 100%;
        height: 70px;
        line-height: 70px;
        background-color: #ffe6a1;
        text-align: center;
        position: absolute;
        z-index: 5;
        font-size: 24px;
        color: #c40000;
    }
    .agentTip .closeTip {
        position: absolute;
        right: 24px;
        top: 0px;
        font-size: 30px;
        color: #282828;
        cursor: pointer;
    }
    .content {
      width: 100%;
      background-image: url(../img/winter/winter_bg_1.png);
      background-repeat: repeat;
      margin-top: -230px;
      // padding-bottom: 230px;
      .footer {
        width: 100%;
        img {
          width: 100%;
        }
      }
    }
    .moocCon {
      width: 1200px;
      text-align: left;
      margin: 0 auto 40px;
      position:relative;
      h3 {
        font-size: 36px;
        color: #0d0d0d;
        position: relative;
        margin-bottom: 25px;
        margin-left: 10px;
        &:before {
          content: '';
          display: inline-block;
          position: absolute;
          left: -10px;
          width: 4px;
          height: 35px;
          background-color: #0c5fce;
        }
        span {
          font-family: "DIN-Medium";
        }
      }
      .moocList {
        .item {
          width: 220px;
          height: 190px;
          box-shadow: 0 0 15px 0 #95a8ad91;
          position: relative;
          border-radius: 5px;
          display: inline-block;
          margin-right: 25px;
          &:last-child {
            margin-right: 0;
          }
          cursor: pointer;
          .hoverCon {
            display: none;
            position: absolute;
            font-size: 24px;
            color: #fff;
            text-align: center;
            line-height: 190px;
            cursor: pointer;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.5);
            span {
              font-size: 20px;
            }
          }
          &:hover {
            .hoverCon {
              display: block;
            }
          }
          .title {
            width: 100%;
            // height: 52px;
            line-height: 52px;
            background-color: #fff;
            font-size: 14px;
            color: #282828;
            text-indent: 0.5em;
          }
        }
      }
    }
    .courseListCon {
        width: 1200px;
        // min-height: 400px;
        
        margin:0 auto 0;
        padding: 0;
        // background-color:#fff;
        text-align: left;
        h3 {
          font-size: 36px;
          display: inline-block;
          color: #0d0d0d;
          position: relative;
          margin-bottom: 25px;
          margin-left: 10px;
          &:before {
            content: '';
            display: inline-block;
            position: absolute;
            left: -10px;
            width: 4px;
            height: 35px;
            background-color: #0c5fce;
          }
          span {
            font-family: "DIN-Medium";
          }
          .time {
            margin-left: 15px;
            color: #999;
            font-size: 20px;
          }
        }
        .tabCon {
          font-size: 30px;
          color: #5b7aa2;
          margin-bottom: 30px;
          span {
            margin-right: 50px;
            cursor: pointer;
          }
          .active {
            color: #0c5fce;
          }
        }
        .liveClass {
            padding-top: 60px;
            margin-bottom: 58px;
        }
        .list {
            width: 1200px;
            margin: auto;
            position: relative;
            padding: 0 0;
            text-align: left;
            .noLive {
              font-size: 20px;
              color: #999;
            }
            // &:before {
            //     position: absolute;
            //     left: 62px;
            //     width: 5px;
            //     height: calc(100% + 66px);
            //     content: '';
            //     background-color: #7ecef4;
            // }
            li {
                display: inline-block;
                vertical-align: top;
                background-color: #fff;
                height: 230px;
                width: 585px;
                margin-left: 0;
                margin-bottom: 30px;
                margin-right: 15px;
                position: relative;
                // &:nth-child(even) {
                //   margin-right: 0;
                // }
                .timeCon {
                  margin: 29px 30px 20px;
                    .time {
                        font-size: 24px;
                        color: #5e696d;
                        font-family: "DIN-Medium";
                    }
                    .live {
                        font-size: 16px;
                        color: #379346;
                        // margin-left: 60px;
                    }
                    .finished {
                        font-size: 16px;
                        color: #93a4aa;
                        // margin-left: 60px;
                    }
                    .notice {
                      font-size: 16px;
                      color: #0c5fce;
                    }
                    .status {
                      float: right;
                    }
                }
                .nameCon {
                    margin-top: 20px;
                    margin-bottom: 15px;
                    padding-left: 30px;
                    .name {
                        font-size: 30px;
                        line-height: 1.2;
                        color: #364347;
                        // width: 100%;
                    }
                    .name_en {
                        font-size: 24px;
                        line-height: 1.2;
                        color: #5e696d;
                        margin-bottom: 8px;
                        font-family: 'Georgia';
                        // width: 924px;
                    }
                }
                .titleCon {
                    .title {
                        color: #3aadd9;
                        display: inline-block;
                        padding-left: 30px;
                        .en {
                            font-size: 24px;
                            font-family: 'Georgia';
                            margin-bottom: 2px;
                            // width: 800px;
                            line-height: 1.2;
                        }
                        .cn {
                            font-size: 18px;
                            // width: 800px;
                            line-height: 1.2;
                        }
                    }
                    .liveBtn {
                        float: right;
                        display: inline-block;
                        font-family: 'Georgia';
                        color: #282828;
                        margin-right: 30px;
                        .join {
                            display: inline-block;
                            height: 50px;
                            line-height: 1.2;
                            border-radius: 25px;
                            background-color: #fcb922;
                            padding: 15px 31px;
                            box-sizing: border-box;
                            cursor: pointer;
                            .En {
                                font-size: 22px;
                                vertical-align: top;
                            }
                            .Cn {
                                font-size: 20px;
                                vertical-align: top;
                            }
                        }
                        .replay {
                            background-color: #7ecef4;
                        }
                        .isOrder {
                            color: #999;
                        }
                        .notOpen {
                          background-color: #b1cab8;
                          
                        }
                    }
                }
            }
            .live:before {
                background-color: #43fd61;
            }
            .finished:before {
                background-color: #d6e1e5;
            }
        }
    }
    
    #videoPlayWrapper {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 999;
    }
    #videoPlayWrapper .closeVideo {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
    }
    .videoContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .videoContainer {
        text-align: center;
        width: 100%;
    }
    .videoContainer video {
        width: 62%;
    }
    // video::-internal-media-controls-download-button {
    //     display:none;
    // }
    // video::-webkit-media-controls-enclosure {
    //     overflow:hidden;
    // }
    // video::-webkit-media-controls-panel {
    //     width: calc(100% + 30px);
    // }
}

</style>
